/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const NameIdContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const IdText = styled(Typography)(({theme}) => ({
  color: `${theme.palette.figma_gray_middle_dark?.main} !important`,
  fontWeight: '400 !important',
  fontSize: '14px !important',
  lineHeight: '16px !important',
}));
